<template>
  <router-link class="btn" :to="href">
    <hr />
    <span class="btn--content">
      <slot />
    </span>
  </router-link>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: {
      type: String,
      default: "Explore",
    },
    href: {
      type: String,
      default: "#",
    },
    callback: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss"></style>
